import { preventNumberScroll } from '@/helpers';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import type { MetadataFieldWithValue } from '@/model/Metadata.model';
import '../MetadataFields.scss';

export interface NumberFieldProps {
  field: MetadataFieldWithValue;
  testId?: string;
}

export const NumberField: FC<NumberFieldProps> = ({ field, testId = 'number-metadata-field' }) => {
  const { register } = useFormContext();
  return (
    <div className="metadata-number-container">
      <input
        type="number"
        onWheel={preventNumberScroll}
        style={{ marginBottom: 0 }}
        step="any"
        defaultValue={field.value ?? ''}
        {...register(`metadata[${field.glossary_api_id}].value`, {
          required: field.required === true && 'This field is required',
        })}
        data-testid={testId}
      />
    </div>
  );
};
